export default function FlattenerFeatures() {
  const features = [
    {
      icon: 'ri-file-reduce-line',
      title: '表单扁平化',
      description: '将动态XFA、静态XFA和AcroForms扁平化为标准PDF文档，防止进一步编辑，确保内容安全。'
    },
    {
      icon: 'ri-palette-line',
      title: '外观流生成',
      description: '自动为注释生成缺失的外观流，确保在所有PDF查看器中正确显示表单内容。'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'JavaScript支持',
      description: '完整支持Adobe和Acrobat JavaScript变体，正确执行表单中的脚本逻辑。'
    },
    {
      icon: 'ri-exchange-line',
      title: 'XFA转AcroForm',
      description: '将XFA表单转换为AcroForms，提高与多种应用程序（包括Acrobat）的兼容性。'
    },
    {
      icon: 'ri-database-2-line',
      title: '数据导入导出',
      description: '支持从外部数据文件导入和导出表单信息，实现批量数据处理。'
    },
    {
      icon: 'ri-printer-line',
      title: '打印/屏幕优化',
      description: '精细调整输出文件中可见的表单字段和数据，针对打印或屏幕显示进行优化。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            程序化扁平化表单
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            PDF Forms Flattener命令行工具可程序化地填充和扁平化表单内容为标准的扁平化PDF文档。无论您使用的是AcroForms、静态XFA还是动态XFA表单，扁平化都能防止进一步编辑，同时在所有设备上保持一致的查看体验。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl hover:border-teal-300 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-50 to-cyan-50 border border-teal-200 rounded-2xl p-8">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              注释显示处理
            </h3>
            <p className="text-gray-700 leading-relaxed">
              PDF Forms Flattener通过设计自动处理注释显示需求，并在扁平化之前应用它们。扁平化后的注释保留在PDF文档中，不需要额外的注释规范，并且无论使用哪种PDF查看器，都能像在Adobe Acrobat中一样一致地显示。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
